import DocumentUpload from "./components/DocumentUpload";
import DocumentUploadWithApptBills from "./components/DocumentUploadWithApptBills";

const UploadDocumentsContainer = ({isUploadOnly = false}) => {
  return (
    <>
    {
      isUploadOnly ?
      (<DocumentUpload/>):
      (<DocumentUploadWithApptBills/>)
    }
    </>
  );
};

export default UploadDocumentsContainer;